/**
 * @file_purpose  page for showing Mail sent Details UI
 * @author Sucheta Singha
 * @Date_Created 21-08-2024
 * @Date_Modified 21-08-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import { GoMail, GoChevronRight, GoVideo } from "react-icons/go";
import Mail from '../../../assets/icons/mail_sent.png'
import MailMsg from '../../../assets/icons/mail.png'
import Vidclap from '../../../assets/icons/video_clap.png'
import Telephone from '../../../assets/icons/telephone-call.png'
import Wp from '../../../assets/icons/wp.png'
import RouteURL from "src/apis/ApiURL";


export default function MailSentDetails() {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
        // setTimeout(() => {
        //     history.push("/app-cost-category");
        // },5000)
    }, [])

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });
    return (
        <body style={{ backgroundColor: "#fff", overflow: 'hidden', scrollbarWidth: 'none' }}>
            <div className='mail_sent_txt'>
                <img src={Mail} alt='' />
                <div className="appoinment_hed">
                    <h4>
                        We've Sent You an Email With The Estimated Cost For Your Project
                    </h4>
                </div>

                <p>The price provided by the calculator is an estimate. <br />The final cost and terms will be determined once all project details are finalized. Please contact us for an accurate quote.</p>
                <div className='row large_btn' >

                    <div className='col-sm-12'>
                        <div className='btn_img_inn'>
                            <button type="button" class="btn btn-lg btn-warning" style={{ marginRight: 10, color: '#fff' }} ><a href="mailto:info@redappletech.com" style={{ color: '#fff' }} target="_top"><img src={MailMsg} alt="" /> info@redappletech.com <i class="fa-solid fa-angle-right"></i></a></button>
                            <button type="button" class="btn btn-warning btn-lg" style={{ marginRight: 10, color: '#fff' }}><a href={RouteURL.webMode == 'production' ? 'https://www.redappletech.com/video-portfolio' : 'https://www.stagingnew.redappletech.com/video-portfolio'} style={{ color: '#fff' }} target="_blank" ><img src={Vidclap} alt='' /> Video Portfolio <i class="fa-solid fa-angle-right"></i></a></button>
                            <button type="button" class="btn btn-warning btn-lg" style={{ marginRight: 10, color: '#fff' }}><a href='https://wa.me/+918017779602' target="_blank" style={{ color: '#fff' }}><img src={Wp} alt="" /> WhatsApp <i class="fa-solid fa-angle-right"></i></a></button>
                            <button type="button" class="btn btn-danger btn-lg" style={{ marginRight: 10 }}><a href={RouteURL.webMode == 'production' ? 'https://www.redappletech.com/book-appointment' : 'https://www.stagingnew.redappletech.com/book-appointment/'} style={{ color: '#fff' }} target="_blank" ><img src={Telephone} alt="" />Book an Appointment <i class="fa-solid fa-angle-right"></i></a></button>
                        </div>
                    </div>

                </div>
            </div>
        </body>

    )
}


